import { connect } from 'react-redux';
import { compose } from 'utils/react';
import { save as saveSite } from 'store/modules/site';
import AnalyticsSettings from '../components/AnalyticsSettings';

export default compose(
  connect(
    ({ site }) => ({
      facebookPixelId: site.facebookPixelId,
      googleAnalyticsId: site.googleAnalyticsId,
      googleTagManagerId: site.googleTagManagerId,
      isSaving: !!site.saving,
      error: site.error,
    }),
    { onSave: saveSite },
  ),
)(AnalyticsSettings);
